export default __webpack_public_path__ + "static/omega-276b35ebfb1f3033606b52bb87fce2b3.jpg";